// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3hL-0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2DRjX"};